// ----------------------------------------------------------------------
// Trilha de navegação da área do aluno.
// Mantida como função pura para ficar testável sem router.
// ----------------------------------------------------------------------

export const STUDENT_ROOT_LABEL = 'Aluno';
export const STUDENT_COURSES_PATH = '/student/courses';
export const STUDENT_COURSE_FALLBACK_LABEL = 'Curso';

const SECTION_LABELS = {
  courses: 'Cursos',
  notifications: 'Notificações',
  profile: 'Meu Perfil',
};

function normalizeSegments(pathname) {
  return String(pathname || '')
    .split('?')[0]
    .split('/')
    .filter(Boolean);
}

/**
 * Monta os links do breadcrumb a partir da rota atual.
 *
 * @param {string} pathname - Ex: "/student/courses/123"
 * @param {{ courseName?: string }} [options] - Nome do curso em foco, quando conhecido.
 * @returns {Array<{ name: string, href?: string }>} Vazio fora da área do aluno.
 */
export function getStudentBreadcrumbs(pathname, { courseName } = {}) {
  const [area, section, ...rest] = normalizeSegments(pathname);

  if (area !== 'student') return [];

  const sectionLabel = SECTION_LABELS[section];
  if (!sectionLabel) return [];

  const links = [{ name: STUDENT_ROOT_LABEL }];

  const isCourseDetail = section === 'courses' && rest.length > 0;

  links.push({
    name: sectionLabel,
    ...(isCourseDetail ? { href: STUDENT_COURSES_PATH } : {}),
  });

  if (isCourseDetail) {
    links.push({ name: courseName || STUDENT_COURSE_FALLBACK_LABEL });
  }

  return links;
}
